import { api } from "../AxiosInstance";

interface EndTripRequest {
  tripId: number;
}

const TripService = {
  endTrip: async (request: EndTripRequest) => {
    try {
      const response = await api.put(`/trip/end-trip?tripId=${request.tripId}`);
      return response;
    } catch (error) {
      console.error("Error ending trip:", error);
      throw error;
    }
  },
  transferTrip: async (
    tripTransferDTOList: { driverId: number; transferDriverId: number }[]
  ) => {
    try {
      const response = await api.post("/trip/transfer", {
        tripTransferDTOList,
      });
      return response;
    } catch (error) {
      console.error("Error transferring trip:", error);
      throw error;
    }
  },
};

export default TripService;
